export const MAIN_NAV = [
    {
        title: "Platform",
        href: "/",
        target: "_self"
    },
    {
        title: "Demo 6.6",
        href: "/demo/",
        target: "_self"
    },
    // {
    //     title: "Готовые решения",
    //     href: "/solutions/",
    //     target: "_self"
    // },
    {
        title: "Price",
        href: "/buy/",
        target: "_self"
    },
    {
        title: "Documentation",
        href: "/docs/",
        target: "_self"
    },
    {
        title: "Download",
        href: "/download/",
        target: "_self"
    },
    {
        title: "About us",
        href: "/about/",
        target: "_self"
    }
]

export const MAIN_NAV_BTN = {
    title: "Forget about ORACLE",
    href: "https://migration.xsquare.ru/",
    target: "_blank"
}
